<!-- src/components/Sidebar.vue -->
<template>
  <el-menu
    :default-active="$route.path"
    class="sidebar-menu"
    
   
    active-text-color="#409EFF"
    :collapse="false"
    router
  >
  <!-- background-color="#304156" :collapse="false"   text-color="#bfcbd9"-->
    <!-- <template v-for="item in menuList">
      <sidebar-item :key="item.path" :item="item" />
    </template> -->
    <sidebar-item v-for="item in menuList" :key="item.path" :item="item" base-path="" />
  </el-menu>
</template>

<script>
import SidebarItem from './SidebarItem.vue'

export default {
  components: { SidebarItem },
  props: {
    menuList: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style>
/* .sidebar-menu:not(.el-menu--collapse) {
  width: 200px;
} */
</style>